import { Component, OnInit, HostListener, ViewChild, ElementRef, AfterViewChecked, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { UiService } from '../../services/ui/ui.service';
import { HelperService } from '../../services/helper/helper.service';
import { UserService } from '../../services/user/user.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var $;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  @ViewChild('myStudiesNav') public myStudiesNav: ElementRef;
  @ViewChild('assignmentNav') public assignmentNav: ElementRef;
  @ViewChild('contactsNav') public contactsNav: ElementRef;
  @ViewChild('coursesNav') public coursesNav: ElementRef;
  @ViewChild('createCourseNav') public createCourseNav: ElementRef;
  @ViewChild('assessmentNav') public assessmentNav: ElementRef;

  public baseRoute: string;
  public nextClassName: any;
  public unreadcount;
  public previousClass: string = "";
  public rolePermission: string;
  public showNavs = {
    myStudies: false,
    assignment: false,
    contacts: false,
    courses: false,
    createCourse: false,
    assessment: false
  };
  public scrollbarOptions = {
    axis: 'y',
    theme: 'minimal',
    autoExpandScrollbar: true,
    // scrollbarPosition: 'outside',
    scrollInertia: 200,
    mouseWheel: { preventDefault: true }
  };
  public newBadge = null;

  constructor(
    public ui: UiService,
    public user: UserService,
    public helper: HelperService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
  ) { }

  @HostListener('window:resize')
  onWindowResize() {
    this.checkWindowSize();
  }

  ngOnInit() {
    this.checkWindowSize();
    this.getUnreadCount();
    this.getNewBadges();
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   const checkNavOpenFn = (showNavsKey, element) => {
    //     const classList = element && element.nativeElement.classList;
    //     this.showNavs[showNavsKey] = (classList && classList.contains('show-child-nav')) || false;
    //   }

    //   const navElems = {
    //     myStudies: this.myStudiesNav,
    //     assignment: this.assignmentNav,
    //     contacts: this.contactsNav,
    //     courses: this.coursesNav,
    //     createCourse: this.createCourseNav,
    //     assessment: this.assessmentNav
    //   };

    //   Object.entries(navElems).forEach(item => checkNavOpenFn(item[0], item[1]));
    // }, 0);
    const navClick = $('.js-show-child-nav');
    const showChildNav = $('.js-open-nav');

    $(navClick).on('click', function (e) {
      e.preventDefault();
      // slideup siblings nav child menu if any open
      $(this).parent().siblings().find(showChildNav).slideUp(200);
      $(this).parent().siblings().find(navClick).removeClass('nav-open');
      // add class and slide down nav child menu when clicked
      $(this).toggleClass('nav-open');
      $(this).siblings(showChildNav).slideToggle(200);
    });
  }

  private checkWindowSize() {
    this.ui.showSidebar = window.innerWidth >= 991;
  }

  getUnreadCount() {
    this.http.get('/message/unread-count').subscribe(
      (res: any) => {
        this.ui.unreadCount = res;
      },
      err => {

      }
    );
  }

  getNewBadges() {
    this.http.get('/bmi-notification/new-badge').subscribe(
      (res: any) => {
        this.newBadge = res;
      },
      err => { }
    );
  }

  removeNewBadge(key) {
    if (this.newBadge && this.newBadge[key]) {
      this.newBadge[key] = 0;
    }
  }

  toggle(key) {
    Object.keys(this.showNavs).forEach(K => {
      this.showNavs[K] = K === key ? !this.showNavs[K] : false;
    })
  }

}



// WEBPACK FOOTER //
// G:/UTL/Alumni/Alumni-ANG/src/app/shared/sidebar/sidebar.component.ts